import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-order-container',
  templateUrl: './order-container.component.html',
  styleUrls: ['./order-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderContainerComponent {
  @Input() order: number;
}
